import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form } from '@deere/ux.uxframe-react';
import { useTranslation } from "react-i18next";
import { findAnswerIndex, updateAnswerInArray, getTranslation } from '../../utils/utils';
import { CAPACITY_CONSTRAINT_SECTION_INDIRECT, EMPTY_BODY, QUESTION_PROPRIETARY } from '../../utils/surveyLiterals'
import store from '../../redux/store'
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';
import RadioGroup from '../../components/RadioGroup';
import { isCheckBoxAnswer, containsCheckBoxAnswer, getNewCheckValueAnswer, removeQuestion } from '../../utils/utils';
import { updateSurveyAnswers, removeSurveyAnswer } from '../../redux/action/surveyAction';
import CheckGroup from '../../components/CheckGroup';
import TableSection from '../../components/TableSection';

import DateOfpSection from '../../components/DateOfpSection';

export default function CapacityConstraints({ survey }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [checkSection] = useState(false);
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const section = survey ? survey.sections.find(e => e.description.toUpperCase() === CAPACITY_CONSTRAINT_SECTION_INDIRECT.toUpperCase()) : [];
    const questions = section.questions.filter(qu => qu.active && qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
    }, [surveyResponse])

    if (!survey)
        return EMPTY_BODY;

    const updateAnswer = (e, questionId) => {
        updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createTextArea(data) {
        let qDepIndex = findAnswerIndex(data.idQuestionDepends, answers);
        let questionIndex = findAnswerIndex(data.id, answers);
        if (data.idQuestionDepends && data.idQuestionDepends > 0) {
            return (qDepIndex >= 0 && answers[qDepIndex].answer >= data.idSelectionDependson) ? <Form.Group className="mb-4 pl-4">
                        <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                        <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, data.id)} name={`${getTranslation(section, 'description')}-${data.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group> : null
        } else {
            return <Form.Group className="mb-4">
                        <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                        <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, data.id)} name={`${getTranslation(section, 'description')}-${data.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group>
        }
    }

    const createRadio = ( question ) => {
        let display = true;
        if(question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            display = qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString();
        }

        if( display ) {
            return <Form.Row className="d-block mb-4">
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <div><RadioGroup key={4} rgIndex={4} radioLabels={question ? question.selections : []}
                            updateAnswer={updateAnswer} question={question}
                            defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(section, 'description')}
                            checkedProprietary={checkSection}/></div>
                    </Form.Group>
                </Form.Row>
        }
    }

    const createOption = ( question, options ) => {
        return <Form.Row className="d-block mb-4">
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                <Form.Control as='select' required={!checkSection} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                    value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                    name={getTranslation(section, 'description')+'-'+question.id}>
                    <option value=''>{t('lbl_dropdown_select')}</option>
                    {options ? options.sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                </Form.Control>
                <div className="invalid-feedback">
                    {t('bs_required')}
                </div>
            </Form.Group>
        </Form.Row>
    }

    const updateCheckAnswer = (e, questionId) => {
        let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {
            removeQuestion(questionId, answers);
            dispatch(removeSurveyAnswer(questionId));
        } else {
            updateAnswerInArray(questionId, answers, newCheckValue);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
        }
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    const createDateSection = ( question ) => {
        let questionIndex = findAnswerIndex(question.idQuestionDepends, answers);
        let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
        let value = '';
        if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(question.idSelectionDependson, ans)) {
            value = question.idSelectionDependson;
        } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
            value = ans;
        }
        return (value && value === question.idSelectionDependson.toString()) ? <DateOfpSection ofpSection={section} dateQuestion={question} updateCheckAnswer={updateCheckAnswer} answers={answers} updateAnswer={updateAnswer} checkedProprietary={checkSection} />: null
    }  

    const createCheck = ( question, ind ) => {
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return(
                    <>
                        <Form.Group className="mb-4 pl-4">
                            <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                            <div><CheckGroup key={question.id} checkSelections={question ? question.selections : []}
                                handleChange={handleCheckChange} question={question}
                                currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                                section={getTranslation(section, 'description')}
                                checkedproprietary={checkSection}/></div>
                        </Form.Group>
                    </>
                )
            }
        }else{
            return(
                <>
                    <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <div><CheckGroup key={question.id} checkSelections={question ? question.selections : []}
                            handleChange={handleCheckChange} question={question}
                            currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(section, 'description')}
                            checkedproprietary={checkSection}/>
                        </div>
                    </Form.Group>
                </>
            )
        }
    }

    const handleCheckChange = (e, idQuestion) => {

        updateCheckAnswer(e, idQuestion);
    } 


    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}
                </Card.Title>
                <>
                    {
                        <>
                            {
                                questions.map((q, index) => {

                                    if(q.type === 'RADIO') {
                                        return createRadio(q);
                                    }

                                    if(q.type === 'OPEN') {
                                        return createTextArea(q);
                                    }
                                    
                                    if(q.type === 'DATE_SECT') {
                                        return createDateSection(q);
                                    }

                                    if( q.type === 'CHECK' ) {
                                        return createCheck( q, index );
                                    }
                                    if( q.type === 'TABLE_SECT' ) {
                                        return <TableSection question={q} updateAnswer={updateAnswer} answers={answers} section={getTranslation(section, 'description')} checkedProprietary={checkSection} questions={questions}/>
                                    }
                                    return <></>
                                })
                            }
                        </>
                    }
                </>
            </Card.Body>
        </Card>
    </>)
}